<div
  class="toast"
  [ngClass]="{ 'toast--open': isOpen, 'toast--closed': !isOpen, 'toast--decommission': isDecommission }"
>
  <div class="toast__content">
    <div class="toast__header">
      <div class="toast__message">
        <p class="toast__title">
          {{ title }}
        </p>
        <p class="toast__description">
          {{ description }}
        </p>
      </div>
      <button
        class="toast__action-button button button--secondary button--small button--white"
        *ngIf="hasActionLink"
        (click)="performAction()"
      >
        {{ linkLabel }}
      </button>
    </div>

    <button class="toast__close-button" *ngIf="hasCloseButton" (click)="close()">
      <img class="toast__close-button-icon" src="/common/img/close-button-white.svg" />
    </button>
  </div>
</div>
